import React, { Component } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import $ from 'jquery';
import config from '../../../config.json';
import { PtInput } from '../../../grit-utilities';


const galleryThumbnail = {
    width: "330px",
    height: "250px",
    marginTop: '10px',
    marginBottom: '10px'
}

const txtStyle={
    fontSize: "15px",
    fontWeight: "bold",
    marginTop: "15px"
}

export default class PhotoGallery extends Component {

    constructor(props) {
        super(props)
        const { minorModel } = this.props;
        
        this.state =
        {
            galleryModel: minorModel.galleryModel,
            selectedIndex: 0,
            nextBtndisable: false,
            prevBtndisable: false,
            uploadResponse: "",
			commentArr: minorModel.galleryModel.Comments,
			layerId: this.props.minorModel.layerId,
			agencyId: this.props.minorModel.agencyId,
            comment: this.props.minorModel.galleryModel.Comments[0]
			
			
        }
        console.log(this.props.minorModel)
    
    }

    componentDidUpdate() {
        this.props.minorModel.galleryModel = this.state.galleryModel;
		
    }
		

    setWebcamRef = element => {
        this.webcam = element;
    }

    setHiddenFileInputRef = element => {
        this.hiddenFileInput = element;
    }

    renameFile = (originalFile, newName) => {
        return new File([originalFile], newName, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });
    }

    uploadFileButtonClick = e => {
        document.getElementById('photo_input').click();
    }

    handleFileChange = e => {
		
        const { name } = e.target
        this.setState({ [name]: e.target.files[0] });
        var data = new FormData();

        // have to get time now and increment in for loop so as to ensure each iteration has unique time 
        // (sometimes it's too speedy and files get same name)
        var time = Date.now();
        var month = new Date().getMonth()
		var date = new Date().getDate()
		var year = new Date().getFullYear()
        
        for (const single_file of e.target.files) {
            //console.log(single_file)
            if (single_file.type == "image/jpeg") {
                // have to make copy with new name because files are immutable for security (agencyID_markerID_time.jpg)
                let renamed_file = this.renameFile(single_file,
                   this.props.minorModel.agencyId + "_" + this.props.minorModel.layerId + "_" + month + "_" + date + "_" + year +"_"+  time + ".jpg");
                time += 5;
                data.append(e.target.name, renamed_file);
            } else {
                console.error("File type must be jpg. This file is not added: " + single_file.name);
            }

        }

        // when done is false, there are entries
        let dataIsNotEmpty = !(data.entries().next().done);

        if (dataIsNotEmpty) {
            let responseMessage = "";
            $.ajax({
                type: "POST",
                url: `${config.server}/upload/ms_photogal`, // /files?
                data: data,
                processData: false,
                contentType: false,

                success: function (response) {
                    if (response['message'] === "Uploaded")
					alert('Photo have been saved please reselect the minor structure to see the updated values')
                }
            });
            this.setState({ uploadResponse: responseMessage });
        } else {
            console.error("Zero valid files selected. Ensure to select only jpeg images.");
        }

    }

    

    next = () => {
        
        if (this.state.selectedIndex === this.state.galleryModel.photos.length - 1)
            this.setState({ nextBtndisable: true })
        else {
            
            let index = this.state.selectedIndex + 1
            this.setState({ selectedIndex: index, nextBtndisable: false, prevBtndisable: false, comment: this.props.minorModel.galleryModel.Comments[index] })
        }
    }
    previous = () => {
        if (this.state.selectedIndex === 0)
            this.setState({ prevBtndisable: true })
        else {
            let index = this.state.selectedIndex - 1
            console.log("Index in prev ",this.state.galleryModel.Comments[index])
            this.setState({ selectedIndex: index, prevBtndisable: false, nextBtndisable: false, comment: this.props.minorModel.galleryModel.Comments[index] })
        }
    }

    deletePhoto = () => {
        this.props.showLoadingSpinner(true)
        const newGalleryModel = { ...this.state.galleryModel }
		let name = this.state.galleryModel.photos[this.state.selectedIndex].split('/')
		
        let finalData = {
            photoKey: this.state.galleryModel.key[this.state.selectedIndex],
            photoPath: this.state.galleryModel.photos[this.state.selectedIndex],
			photoName: name[name.length-1]
        };
		
        $.ajax({
            type: 'POST',
            url: `${config.server}\\deleteminorphoto`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),

            success: (data) => {
                console.log('Success data ', data)
                this.props.showLoadingSpinner(false);
                newGalleryModel.key.splice(this.state.selectedIndex, 1)
                newGalleryModel.photos.splice(this.state.selectedIndex, 1)
                newGalleryModel.photopath.splice(this.state.selectedIndex, 1)
                this.setState({ galleryModel: newGalleryModel })
            },
        });
    }
	
	saveComment = () => {
		
         let finalData = {
            photoKey: this.state.galleryModel.key[this.state.selectedIndex],
		    commentList: this.state.comment
        };
        $.ajax({
            type: 'POST',
            url: `${config.server}\\savephotocomment`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),

            success: (data) => {
                console.log('Success data ', data)
				if (data['message'] === "OK")
					alert('Comments have been saved please reselect the minor structure to see the updated values')
                
            },
        });
    }
	
	onUpdateItems = (e) => {        
        const {name,value} = e.target
        this.setState({[name]:value})
        
      };
	
    formatDate(string){
		var options = { year: 'numeric', month: 'long', day: 'numeric' };
		return new Date(string).toLocaleDateString([],options);
	}

    render() {
        // the button works to allow uploading or camera image(on mobile) so display text based off of device.
        const buttonText = this.state.mobileTabletCheck ? "Take photo or Upload Photos from Device" : "Upload Photos from Device";
        return (
            <div id="root">
                {<Grid>
                    <Grid.Column textAlign="center">
                       {!this.props.minorModel.FlagForGallery &&
                        <Button size='small' onClick={this.uploadFileButtonClick} color='green' disabled={this.props.disabled} align="center">{buttonText}</Button>
                       }
                       {this.state.galleryModel.photos.length===0 && this.props.minorModel.FlagForGallery &&
                         <p style={{ marginTop: "10px", textAlign: "center", color: "red" }}> Please First Save the Minor Structure to use the Gallery Tab</p>
                       }
                    </Grid.Column>
                </Grid>}
                <form id="frmUploader" encType="multipart/form-data" action="/upload/ms_photogal" method="post">
                    <input id="photo_input" name="selectedFile" type="file" onChange={this.handleFileChange} ref={this.setHiddenFileInputRef}
                        style={{ display: 'none' }} accepts="image/jpeg" multiple />
                </form>
               
                {this.state.galleryModel.photos.length > 0 &&
                        <img style={galleryThumbnail} src={this.state.galleryModel.photos[this.state.selectedIndex]} />}

                {
                    this.state.galleryModel.photos.length > 0 && 
                    <PtInput type="text" label="Comment" 
                   value = {this.state.comment === null ? 'Not Available' : this.state.comment}
                    onChange={this.onUpdateItems} name= "comment" disabled={this.props.disabled}/>     
                }

				


                 {this.state.galleryModel.photos.length > 0 && 
                    <Button color="green" disabled={this.props.disabled} onClick={() => this.saveComment()} >Save Comment</Button>}



                {this.state.galleryModel.photos.length > 0 && 
                <p style={txtStyle}>Uploaded On:{this.formatDate(this.state.galleryModel.datecreated[this.state.selectedIndex])}</p> }
                    
                {this.state.galleryModel.photos.length === 0 && !this.props.minorModel.FlagForGallery &&
                    <p style={{ marginTop: "10px", textAlign: "center", color: "red" }}> No Images Available for this Minor Structure.</p>}

                {this.state.galleryModel.photos.length > 0 && 
                    <p style={txtStyle}>Image {this.state.selectedIndex + 1}/{this.state.galleryModel.photos.length}</p>}

                {this.state.galleryModel.photos.length > 0 && 
                    <Button disabled={this.state.prevBtndisable} onClick={() => this.previous()}>Previous</Button>}

                {this.state.galleryModel.photos.length > 0 && 
                    <Button disabled={this.state.nextBtndisable} onClick={() => this.next()} >Next</Button>}

                {this.state.galleryModel.photos.length > 0 && 
                    <Button color="teal" disabled={this.props.disabled} onClick={() => this.deletePhoto()} >Delete Photo</Button>}
    
				

                {this.state.uploadResponse !== "" && <p style={txtStyle}>Images Uploaded!</p>}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/layers/tabs/minor-structs/photogallery2.js